<template>
    <div
        id="missing-card-success-step"
        class="manual-step flex flex-col h-full"
    >
        <!-- Main Container - Success State -->
        <div
            class="flex w-full p-6 flex-col items-center gap-8 rounded-none md:rounded-lg bg-white dark:bg-slate-800 shadow-none md:shadow-[0_1px_3px_0_rgba(0,0,0,0.10),0_1px_2px_0_rgba(0,0,0,0.06)] pb-24 md:pb-6 flex-1 min-h-0 overflow-y-auto"
        >
            <!-- Header Container -->
            <div class="flex items-start justify-between self-stretch">
                <div class="flex items-center gap-4">
                    <!-- Pill with Icon -->
                    <div
                        class="flex w-12 h-12 p-3.5 flex-col justify-center items-center gap-2.5 rounded-full bg-slate-100 dark:bg-slate-700"
                    >
                        <Icon
                            icon="unknown-card"
                            class="w-5 h-5 text-slate-600 dark:text-slate-300"
                        />
                    </div>

                    <!-- Title -->
                    <h2
                        class="text-slate-800 dark:text-slate-100 text-xl font-medium leading-7"
                    >
                        Missing card request
                    </h2>
                </div>
                <button
                    type="button"
                    @click="$emit('close')"
                    class="btn-icon btn-transparent w-10"
                >
                    <Icon icon="close" />
                </button>
            </div>

            <!-- Success Content -->
            <div
                class="flex-1 flex flex-col items-center justify-center self-stretch"
            >
                <!-- Success Icon -->
                <div
                    class="flex w-16 h-16 justify-center items-center gap-2.5 rounded-full bg-emerald-50"
                >
                    <Icon
                        icon="check-green"
                        class="w-8 h-8 flex-shrink-0"
                    />
                </div>

                <!-- Success Info Container -->
                <div
                    class="flex w-full max-w-[560px] pt-4 pb-6 flex-col items-center gap-4 mx-auto"
                >
                    <!-- Success Title -->
                    <h3
                        class="w-full text-slate-800 dark:text-slate-100 text-center text-xl font-medium leading-7"
                    >
                        Card request sent
                    </h3>

                    <!-- Success Description -->
                    <p
                        class="w-full text-slate-800 dark:text-slate-100 text-center text-sm font-normal leading-5"
                    >
                        Our team will review and work on adding it as
                        soon as possible. You'll get an email
                        notification once the card is available in the
                        list.
                    </p>
                </div>
            </div>
        </div>

        <!-- Mobile bottom bar: Ok, got it with 48px bottom space -->
        <div
            class="md:hidden fixed bottom-12 left-0 right-0 bg-white dark:bg-slate-800 px-4 pt-3 pb-[max(12px,env(safe-area-inset-bottom))] z-[1000]"
        >
            <button
                type="button"
                @click.prevent="$emit('close')"
                class="w-full py-3 rounded-md border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-sm font-medium leading-5 hover:bg-slate-50 dark:hover:bg-slate-700"
            >
                Ok, got it
            </button>
        </div>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';

defineEmits(['close']);
</script>
